/**
 * スライドを移動とis-activeクラスを制御
 * @param {Number} index 中央に持ってきたいスライドのインデックス
 * @param {Array} listItems 目次のリスト
 * @param {} splide インスタンス化したsplide
 */

export const showSlide = (index, listItems, splide) => {
  listItems.forEach((item) => item.classList.remove('is-active'));
  listItems[index].classList.add('is-active');
  // 対応するスライドに移動
  splide.go(index);
};
